import { coreActions } from "../slices/core.slice"
import { getStoreRef } from "../store-ref"

/**
 * Show a global alert modal.
 *
 * Usage:
 *   showFoneAlert({ type: "warning", title: "Delete?", text: "Are you sure?" ... })
 */
export const showFoneAlert = (alertData: Record<string, any>) => {
  getStoreRef().dispatch(
    coreActions.showAlert(alertData)
  )
}

/**
 * Close the global alert modal.
 */
export const closeFoneAlert = () => {
  getStoreRef().dispatch(
    coreActions.closeAlert()
  )
}
